import { createActions, createReducer } from 'reduxsauce'

export const { Types, Creators } = createActions({
  getActiveCircularsRequest: [],
  getActiveCircularsFailure: [],
  getActiveCircularsSuccess: ['data', 'total'],
  getCircularsRequest: [],
  getCircularsFailure: [],
  getCircularsSuccess: ['data', 'total'],
  setCircularsSort: ['sort', 'direction'],
  setCircularsPage: ['page', 'limit'],
  getCircularRequest: ['id'],
  getCircularSuccess: ['data'],
  getCircularFailure: [],
  resetCircularData: [],
  resetCircular: [],
  removeCircularRequest: ['id', 'callback'],
  removeCircularFinish: [],
  addCircularRequest: ['data', 'callback'],
  addCircularFailure: [],
  addCircularSuccess: [], // Added missing success action
  updateCircularRequest: ['id', 'data', 'callback'],
  updateCircularFinish: [],
  getCircularFunctionsRequest: [],
  getCircularFunctionsFailure: [],
  getCircularFunctionsSuccess: ['data', 'total'],
  setCircularsSearch: ['value'],
  getAllDepartmentsRequest: [],
  getAllDepartmentsSuccess: ['data'],
  getAllDepartmentsFailure: [],
})

const INITIAL_STATE = {
  options: {
    sort: 'created_at',
    direction: 'desc',
    search: '',
    page: 0,
    total: 0,
    limit: 20,
  },
  data: [],
  circularData: null,
  loading: false,
  dataFunctions: [],
  departments: {
    data: [],
    loading: false,
  },
  allDepartments: {
    data: [],
    loading: false,
  },
}

const getActiveCircularsRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})

const getActiveCircularsFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
})

const getActiveCircularsSuccess = (state = INITIAL_STATE, { data, total }) => ({
  ...state,
  options: {
    ...state.options,
    total,
  },
  data,
  loading: false,
})

const getCircularsRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})

const getCircularsFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
})

const getCircularsSuccess = (state = INITIAL_STATE, { data, total }) => ({
  ...state,
  options: {
    ...state.options,
    total,
  },
  data,
  loading: false,
})

const setCircularsSort = (state = INITIAL_STATE, { sort, direction }) => ({
  ...state,
  options: {
    ...state.options,
    sort,
    direction,
    page: 0,
  },
})

const setCircularsPage = (state = INITIAL_STATE, { page, limit }) => ({
  ...state,
  options: {
    ...state.options,
    page,
    limit,
  },
})

const getCircularRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})

const getCircularSuccess = (state = INITIAL_STATE, { data }) => ({
  ...state,
  circularData: {
    ...data,
    active: String(data.active),
  },
  loading: false,
})

const getCircularFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
})

const resetCircularData = (state = INITIAL_STATE) => ({
  ...state,
  circularData: null,
  loading: false,
})


const removeCircularRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})

const removeCircularFinish = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
})

const addCircularRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})

const addCircularFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
})

const addCircularSuccess = (state = INITIAL_STATE) => ({ // Added reducer for success
  ...state,
  loading: false,
})

const updateCircularRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})

const updateCircularFinish = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
})

const getCircularFunctionsRequest = (state = INITIAL_STATE) => ({
  ...state,
  loading: true,
})

const getCircularFunctionsSuccess = (state = INITIAL_STATE, { data }) => ({
  ...state,
  dataFunctions: data,
  loading: false,
})

const getCircularFunctionsFailure = (state = INITIAL_STATE) => ({
  ...state,
  loading: false,
})

const setCircularsSearch = (state = INITIAL_STATE, { value }) => ({
  ...state,
  options: {
    ...state.options,
    search: value,
    page: 0,
  },
})

const getAllDepartmentsRequest = (state = INITIAL_STATE) => ({
  ...state,
  allDepartments: {
    ...state.allDepartments,
    loading: true,
  },
})

const getAllDepartmentsSuccess = (
  state = INITIAL_STATE,
  { data },
) => ({
  ...state,
  allDepartments: {
    ...state.allDepartments,
    data,
    loading: false,
  },
})

const getAllDepartmentsFailure = (state = INITIAL_STATE) => ({
  ...state,
  allDepartments: {
    ...state.allDepartments,
    loading: false,
  },
})

export default createReducer(INITIAL_STATE, {
  [Types.GET_ACTIVE_CIRCULARS_REQUEST]: getActiveCircularsRequest,
  [Types.GET_ACTIVE_CIRCULARS_FAILURE]: getActiveCircularsFailure,
  [Types.GET_ACTIVE_CIRCULARS_SUCCESS]: getActiveCircularsSuccess,
  [Types.GET_CIRCULARS_REQUEST]: getCircularsRequest,
  [Types.GET_CIRCULARS_FAILURE]: getCircularsFailure,
  [Types.GET_CIRCULARS_SUCCESS]: getCircularsSuccess,
  [Types.SET_CIRCULARS_SORT]: setCircularsSort,
  [Types.SET_CIRCULARS_PAGE]: setCircularsPage,
  [Types.GET_CIRCULAR_REQUEST]: getCircularRequest,
  [Types.GET_CIRCULAR_SUCCESS]: getCircularSuccess,
  [Types.GET_CIRCULAR_FAILURE]: getCircularFailure,
  [Types.RESET_CIRCULAR_DATA]: resetCircularData,
  [Types.REMOVE_CIRCULAR_REQUEST]: removeCircularRequest,
  [Types.REMOVE_CIRCULAR_FINISH]: removeCircularFinish,
  [Types.ADD_CIRCULAR_REQUEST]: addCircularRequest,
  [Types.ADD_CIRCULAR_FAILURE]: addCircularFailure,
  [Types.ADD_CIRCULAR_SUCCESS]: addCircularSuccess, // Mapped the new success reducer
  [Types.UPDATE_CIRCULAR_REQUEST]: updateCircularRequest,
  [Types.UPDATE_CIRCULAR_FINISH]: updateCircularFinish,
  [Types.GET_CIRCULAR_FUNCTIONS_REQUEST]: getCircularFunctionsRequest,
  [Types.GET_CIRCULAR_FUNCTIONS_FAILURE]: getCircularFunctionsFailure,
  [Types.GET_CIRCULAR_FUNCTIONS_SUCCESS]: getCircularFunctionsSuccess,
  [Types.SET_CIRCULARS_SEARCH]: setCircularsSearch,
  [Types.GET_ALL_DEPARTMENTS_REQUEST]: getAllDepartmentsRequest,
  [Types.GET_ALL_DEPARTMENTS_SUCCESS]: getAllDepartmentsSuccess,
  [Types.GET_ALL_DEPARTMENTS_FAILURE]: getAllDepartmentsFailure,
})
